export interface InstructorCoursesResponse {
  data: InstructorCourse[];
}

export interface InstructorCourse {
  launch_course_id: string;
  vbid: string;
  course_title: string;
}

export type InstructorCourses = InstructorCourse[];

export const getInstructorCourses = (
  sessionId: string
): Promise<{ ok: boolean; data: InstructorCourse[] }> =>
  fetch(
    `https://${
      import.meta.env.VITE_TIGHTROPE_HOST
    }/lms/v1/api/instructor_courses/?session_id=${sessionId}&tenant_id=bookshelf`,
    {
      method: "GET",
    }
  )
    .then((resp: Response) => resp.json())
    .then((resp: InstructorCoursesResponse) => {
      if (!resp.data) {
        return { ok: false, data: [] };
      } else {
        return { ok: true, data: resp.data };
      }
    })
    .catch(() => {
      return { ok: false, data: [] };
    });
